import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Column 1: Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold tracking-tight">ODI LOGISTICS</h3>
            <p className="text-gray-400">Safe. Secure. Fast.</p>
          </div>

          {/* Column 2: Nigeria Offices */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg text-gray-200">Nigeria</h4>
            <div className="text-gray-400 space-y-2">
              <p>
                <strong className="text-gray-300">Ibadan:</strong><br />
                9 Okeremi Ave, Mokola
              </p>
              <p>
                <strong className="text-gray-300">Iseyin:</strong><br />
                1 Oremeji St, Malete
              </p>
              <p>
                <a href="tel:+2348082773235" className="hover:text-white transition-colors">
                  +234 (0)808 277 3235
                </a>
              </p>
            </div>
          </div>

          {/* Column 3: International */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg text-gray-200">International</h4>
            <div className="text-gray-400 space-y-2">
              <p><strong className="text-gray-300">United Kingdom</strong></p>
              <p>
                <a href="tel:+447958140705" className="hover:text-white transition-colors">
                  +44 (0)795 814 0705
                </a>
              </p>
            </div>
          </div>

          {/* Column 4: Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-lg text-gray-200">Contact Us</h4>
            <div className="text-gray-400 space-y-2">
              <p>
                <a href="mailto:sales@odi-logistics.com" className="hover:text-white transition-colors">
                  sales@odi-logistics.com
                </a>
              </p>
              <p className="text-sm">Visit one of our branches or give us a call.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-900 py-4">
        <p className="text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} ODI Logistics Limited. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;